import { useQuery } from '@tanstack/react-query';
import { EPlatformQueryKey, usePlatformStore } from 'entities/platform';
import { useCustomerId } from 'entities/user';

export const usePlatforms = () => {
  const fetchPlatforms = usePlatformStore(state => state.fetchPlatforms);
  const platforms = usePlatformStore(state => state.list);
  const customerId = useCustomerId()

  const platformsQuery = useQuery({
    queryKey: [
      EPlatformQueryKey.PLATFORMS,
    ],
    queryFn: () => fetchPlatforms(customerId),
  });

  return {
    platforms,
    platformsQuery,
  };
};
